var _excluded = ["placement"],
  _excluded2 = ["className"],
  _excluded3 = ["className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import { forwardRef, tqc, useStyles } from '../../system';
import { cx } from '../../utils';
var StyledElement = tqc('div', {
  baseStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '0',
    zIndex: 2
  }
});
var InputElement = forwardRef((props, ref) => {
  var _input$height, _input$height2, _input$paddingLeft;
  var {
      placement = 'left'
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var styles = useStyles();
  var input = styles.field;
  var elementStyles = {
    [placement]: '0',
    width: (_input$height = input === null || input === void 0 ? void 0 : input.height) !== null && _input$height !== void 0 ? _input$height : input === null || input === void 0 ? void 0 : input.h,
    height: (_input$height2 = input === null || input === void 0 ? void 0 : input.height) !== null && _input$height2 !== void 0 ? _input$height2 : input === null || input === void 0 ? void 0 : input.h,
    fontSize: input === null || input === void 0 ? void 0 : input.fontSize,
    paddingX: (_input$paddingLeft = input === null || input === void 0 ? void 0 : input.paddingLeft) !== null && _input$paddingLeft !== void 0 ? _input$paddingLeft : input === null || input === void 0 ? void 0 : input.pl
  };
  return /*#__PURE__*/React.createElement(StyledElement, _extends({
    ref: ref,
    __css: elementStyles
  }, rest));
});
InputElement.id = 'InputElement';
InputElement.displayName = 'InputElement';
export var InputLeftElement = forwardRef((props, ref) => {
  var {
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  var _className = cx('tqc-input__left-element', className);
  return /*#__PURE__*/React.createElement(InputElement, _extends({
    ref: ref,
    placement: "left",
    className: _className
  }, rest));
});
InputLeftElement.id = 'InputLeftElement';
InputLeftElement.displayName = 'InputLeftElement';
export var InputRightElement = forwardRef((props, ref) => {
  var {
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  var _className = cx('tqc-input__right-element', className);
  return /*#__PURE__*/React.createElement(InputElement, _extends({
    ref: ref,
    placement: "right",
    className: _className
  }, rest));
});
InputRightElement.id = 'InputRightElement';
InputRightElement.displayName = 'InputRightElement';